// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uptype-content {\n  height: 100%;\n  max-height: 600px !important;\n  min-height: 500px !important;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
